var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 6.667a.833.833 0 0 0-.833-.834H3.833l-.097.006A.833.833 0 0 0 3.833 7.5h13.334l.097-.006A.833.833 0 0 0 18 6.667m0 6.666a.833.833 0 0 0-.833-.833H3.833l-.097.006a.834.834 0 0 0 .097 1.66h13.334l.097-.005a.833.833 0 0 0 .736-.828",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;